module.exports = __webpack_public_path__ + "static/sun_city-8ea884d8485631a3064114ac384a3fee.png";